// extracted by mini-css-extract-plugin
export default {"XL":"index-module--XL--61d37","L":"index-module--L--e8abf","M":"index-module--M--f7215","S":"index-module--S--7c28d"};